"use client"

import * as React from "react"
import { graphql } from "gatsby"

import { StoryblokStory } from "gatsby-source-storyblok"

import Seo from "../components/seo"
import Layout from "../components/layout"

/**
 * The Storyblock component maps content to its respective components if set up
 * accordingly in layout.js
 *
 * This means that this component is just a wrapper and the actual changes
 * should be done in it's respective component
 */
const IndexPage = ({ data, pageContext }) => {
  if (typeof data.storyblokEntry.content === "string") data.storyblokEntry.content = JSON.parse(data.storyblokEntry.content);

  return (
    <Layout>
      <StoryblokStory
        name={data.storyblokEntry.name}
        published_at={data.storyblokEntry.published_at}
        story={data.storyblokEntry}
        pageContext={pageContext}
        context={pageContext}
        bridgeOptions={{
          resolveRelations: [
            "quote_reference.quote",
            "quote.company",
            "social_media_entry.platform",
            "news.Category",
          ],
          resolveLinks: "url",
          preventClicks: true,
        }}
      />
    </Layout>
  )
}

export const Head = ({ data }) => {
  const entry = data.storyblokEntry
  const { metatags } = entry.content

  if(!metatags){
    return (
      <Seo />
    )
  }

  return(
    <Seo
      title={metatags.title}
      description={metatags.description}
      ogTitle={metatags.og_title}
      ogImage={metatags.og_image}
      ogDescription={metatags.og_description}
      twitterTitle={metatags.twitter_title}
      twitterImage={metatags.twitter_image}
      twitterDescription={metatags.twitter_description}
    />
  )
}

export default IndexPage

export const query = graphql`
  query ($full_slug: String) {
    storyblokEntry(full_slug: { eq: $full_slug}) {
      content
      name
      full_slug
      uuid
      id
      internalId
      published_at
    }
  }
`
